export enum AppEnvironmentEnum {
	UNKNOWN = 'UNKNOWN',
	LOCAL = 'LOCAL',
	DEV = 'DEVELOPMENT',
	TEST = 'TEST',
	LIVE = 'LIVE'
}
